module.exports = new __parcel__URL__("vivun.00829975.svg").toString();